import React from 'react';

import useFormatPrice from '@/lib/hooks/use-format-price';

interface PriceDisplayProps {
  value: number | undefined;
  sqm?: boolean;
  compact?: boolean;
  bold?: boolean;
  activeColor?: boolean;
  colorBasedOnValue?: boolean;
  showSign?: boolean;
  unitClassName?: string;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  value,
  sqm = false,
  compact = false,
  bold = false,
  activeColor = false,
  colorBasedOnValue = false,
  showSign = false,
  unitClassName,
}) => {
  const price = useFormatPrice(value, compact) || '-';
  const unit = sqm ? 'kr/m²' : 'kr';

  const color = colorBasedOnValue
    ? value === 0
      ? ''
      : (value ?? 0) > 0
      ? 'text-success'
      : 'text-error'
    : activeColor
    ? 'text-primary dark:text-primary-45'
    : '';

  return (
    <span className={`${bold ? 'font-medium' : ''}`}>
      <span className={color}>
        {showSign && value && value > 0 ? '+' : null}
        {price}
      </span>{' '}
      <span
        className={`normal-case text-superLight-textLight ${
          unitClassName || ''
        }`}
      >
        {' '}
        {unit}
      </span>
    </span>
  );
};

export default PriceDisplay;
